import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 五菱招标采购下路由
 */
export default [
  // 采购端
  {
    path: 'purchaser',
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: '招标采购',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
    roles: [
      platformFunctionModuleDict.PURCHASER.right,
      platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
      platformFunctionModuleDict.WL_TECH_REVIEW.right,
      platformFunctionModuleDict.WL_OPEN_MANAGER.right
    ],
    superviseInstitutions: [],

    children: [
      {
        path: 'wl-bid',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '招标采购',
          layout: 'DefaultLayout',
          icon: 'icon-side_purchase_bid',
          microName: 'wuling',
          isMicro: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
        roles: [
          platformFunctionModuleDict.PURCHASER.right,
          platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        ],
        superviseInstitutions: [],
        children: [
          {
            path: 'WulingProject',
            name: `WLBidList`,
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              microName: 'wuling',
              cache: true,
              hidden: true,
              isMicro: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
            roles: [
              platformFunctionModuleDict.PURCHASER.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 开标管理
      {
        path: 'wl-open',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '开标管理',
          layout: 'DefaultLayout',
          icon: 'icon-side_purchase_bid',
          microName: 'wuling',
          isMicro: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
        roles: [
          platformFunctionModuleDict.WL_OPEN_MANAGER.right,
          platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        ],
        superviseInstitutions: [],
        children: [
          {
            path: 'WlAdminBidOpenList',
            name: `WlAdminBidOpenList`,
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              microName: 'wuling',
              cache: true,
              hidden: true,
              isMicro: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
            roles: [
              platformFunctionModuleDict.WL_OPEN_MANAGER.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 技术评审
      {
        path: 'wl-tech-review',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '技术评审',
          layout: 'DefaultLayout',
          icon: 'icon-side_purchase_bid',
          microName: 'wuling',
          isMicro: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
        roles: [
          platformFunctionModuleDict.WL_TECH_REVIEW.right,
          platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        ],
        superviseInstitutions: [],
        children: [
          {
            path: 'WlTechTechnologyReviewList',
            name: `WlTechTechnologyReviewList`,
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              microName: 'wuling',
              cache: true,
              hidden: true,
              isMicro: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
            roles: [
              platformFunctionModuleDict.WL_TECH_REVIEW.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      }
    ]
  },

  // 供应商
  {
    path: 'supplier',
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: '投标报价',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
      { companyType: companyTypeDict.SELF_EMPLOYEE.value },
      { companyType: companyTypeDict.PERSON.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
    roles: [
      platformFunctionModuleDict.SUPPLIER.right,
      platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
    ],
    superviseInstitutions: [],

    children: [
      {
        path: 'participate',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '已参与项目',
          icon: 'icon-side_supplier_involved',
          layout: 'DefaultLayout'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
          { companyType: companyTypeDict.SELF_EMPLOYEE.value },
          { companyType: companyTypeDict.PERSON.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
        roles: [
          platformFunctionModuleDict.SUPPLIER.right,
          platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        ],
        superviseInstitutions: [],
        children: [
          {
            path: 'bid',
            type: menuTypeDict.DIRECTORY.value,
            meta: {
              title: '招标采购',
              layout: 'DefaultLayout'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
              { companyType: companyTypeDict.SELF_EMPLOYEE.value },
              { companyType: companyTypeDict.PERSON.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
            roles: [
              platformFunctionModuleDict.SUPPLIER.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: [],
            children: [
              {
                path: 'WulingBidTrade',
                name: 'WulingBidTrade',
                type: menuTypeDict.MENU.value,
                meta: {
                  title: '项目详情',
                  microName: 'wuling',
                  cache: false,
                  hidden: true,
                  isMicro: true
                },
                applicableCompanyTypes: [
                  { companyType: companyTypeDict.ENTERPRISE.value },
                  { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                  { companyType: companyTypeDict.SELF_EMPLOYEE.value },
                  { companyType: companyTypeDict.PERSON.value }
                ],
                platformAlias: [],
                applicableCompanyIdentities: [
                  workbenchServiceDict.SUPPLIER.value
                ],
                roles: [
                  platformFunctionModuleDict.SUPPLIER.right,
                  platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
                ],
                superviseInstitutions: []
              }
            ]
          }
        ]
      }
    ]
  },

  // 查询统计
  {
    path: 'monitor',
    type: menuTypeDict.DIRECTORY.value,
    meta: { title: '查询统计', layout: 'DefaultLayout' },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities: [],
    roles: [
      platformFunctionModuleDict.QUERY_STATS.right,
      platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
    ],
    superviseInstitutions: [],

    children: [
      {
        path: 'purchaser',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '采购项目查询',
          icon: 'icon-side_statistics_purchase'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
        roles: [
          platformFunctionModuleDict.QUERY_STATS.right,
          platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        ],
        superviseInstitutions: [],
        children: [
          {
            path: 'wl-bid',
            type: menuTypeDict.DIRECTORY.value,
            meta: {
              title: '招标采购',
              layout: 'DefaultLayout',
              icon: 'icon-side_purchase_bid',
              microName: 'wuling',
              isMicro: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [],
            roles: [
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
              platformFunctionModuleDict.QUERY_STATS.right
            ],
            superviseInstitutions: [],
            children: [
              {
                path: 'WlMonitorBidList',
                name: `WlMonitorBidList`,
                type: menuTypeDict.MENU.value,
                meta: {
                  title: '项目列表',
                  microName: 'wuling',
                  cache: true,
                  hidden: true,
                  isMicro: true
                },
                applicableCompanyTypes: [
                  { companyType: companyTypeDict.ENTERPRISE.value },
                  { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
                ],
                platformAlias: [],
                applicableCompanyIdentities: [],
                roles: [
                  platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
                  platformFunctionModuleDict.QUERY_STATS.right
                ],
                superviseInstitutions: []
              }
            ]
          }
        ]
      }
    ]
  }
]
